import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class RealEstate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Real Estate </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                    Thanks to new XR technologies, all you have to do is put a VR headset 
                    on and get yourself immersed into another reality. All the perks of an 
                    open house without the need to attend one. Real estate companies see huge 
                    potential in the use of both VR and AR. While Virtual Reality can serve as 
                    an alternative to open house, Augmented Reality might help potential customers 
                    visualize their for-now-empty-homes with furniture and decor.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Virtual viewing can help both real estate agents and home buyers feel 
                      so much more confident about buying (or in Rentberry’s case, renting) sights unseen.
                      And that’s important because according to Redfin, 1 in 3 home buyers 
                      make their offers without ever seeing the property in real life.
                      <br></br> 
                      That’s up from barely 1 in 5 just one year ago.
                      These days, 95% of buyers use the internet to look for homes, and 51% buy 
                      homes that they have found using the internet.
                      On top of that, NAR’s 2017 study found that only buyers over the age of 71 
                      are contacting a Realtor before looking online. Compare that to the 71% of 
                      millennials who are excited about VR and the math just makes sense.
                      <br></br> 
                      VR and AR technologies are literally the future, even in a people business like real estate.
                      And that’s really a wonderful thing. VR and AR tech can help agents make a 
                      stellar first impression with both home buyers and sellers, solve common communication 
                      challenges with prospects, and even help agents spend their time more wisely by not 
                      taking buyers to view properties you know they won’t like.
                      All of which will result in closing more deals in less time.
                      <br></br> 
                      Have you ever wondered how this technology can assist in a seemingly unrelated domain 
                      like architecture? Well, it is possible. AbilitàXR has the power to transform 
                      bland architect models and renderings into unique, refreshingly immersive experiences 
                      for the decision-makers. We get a better sense of how individual components would look, 
                      feel, interact, and function in a finished residential or commercial property.
                      The buyer doesn’t need to visit the property physically. We can choose the one they 
                      like by touring them virtually. Within a matter of minutes, the buyer can have a 360-degree 
                      view of the interiors, exteriors, surrounding areas, and 3D walkthroughs of different properties. 
                      This way, with VR, he can make a decision whether to buy the property or not.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Real Estate templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default RealEstate;



// WEBPACK FOOTER //
// ./src/views/Pages/RealEstate/RealEstate.js